import { Controller } from "stimulus"

export default class extends Controller {

  static values = {
    indexUrl: String
  };

  connect() {
  }

  onItemPerPageChange(e) {
    e.preventDefault();
    const value = e.target.value;
    location.replace(`${this.indexUrlValue}?items=${value}`);
  }
}
